var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneySecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 15 16",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.49925 3.75c.00075-.82875-1.67925-1.5-3.74925-1.5s-3.7485.672-3.75 1.5c0 .82875 1.6785 1.5 3.75 1.5s3.75-.67125 3.75-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 3.75v5.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.00075 6.75c0 .82875 1.6785 1.5 3.75 1.5s3.75-.67125 3.75-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.7615 9.9885c1.31775 1.31775 1.31775 3.45525 0 4.773s-3.45525 1.31775-4.773 0-1.31775-3.45525 0-4.773 3.45525-1.31775 4.773 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.37875 10.81875c-.6765.26625-1.60425.43125-2.62875.43125-2.07075 0-3.74925-.67125-3.74925-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.33375 13.833c-.67275.25725-1.5795.417-2.58375.417-2.07075 0-3.74925-.67125-3.75-1.5v-9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySecond);
export default __webpack_public_path__ + "static/media/money-second.b61e0bf982ddc096ed456591bb356a4f.svg";
export { ForwardRef as ReactComponent };